import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TileStats } from '../common/types/tiles';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private loadingSub: Subject<Loading> = new Subject<Loading>();
  public loading$: Observable<Loading> = this.loadingSub.asObservable();

  constructor(private http: HttpClient) {}

  public loadingChange(isLoading: boolean, isFixed: boolean = false): void {
    this.loadingSub.next({ isLoading, isFixed });
  }

  public fetchTilesStats(): Observable<TileStats> {
    return this.http.get<TileStats>(
      `${environment.baseApi}/client/tiles-stats`
    );
  }

  public retrieveAssets(cursor?: string, limit: number = 50): Observable<any> {
    this.loadingChange(true);
    return this.http
      .get(
        `${environment.baseApi}/client/opensea/user-balance?cursor=${
          cursor || ''
        }&pageSize=${limit}`
      )
      .pipe(finalize(() => this.loadingChange(false)));
  }

  public reportNft(tileId: string): Observable<any> {
    this.loadingChange(true);
    return this.http
      .post(`${environment.baseApi}/client/reports/nft`, {
        tileId,
      })
      .pipe(finalize(() => this.loadingChange(false)));
  }
}

interface Loading {
  isLoading: boolean;
  isFixed: boolean;
}
